export const ProducerEndpoints = {
  producerById: '/producers/{id}',
  producerFullById: '/producers/{id}/full',
  producerExternal: '/producers/{id}/external',
  producerSearch: '/producers',
} as const;
